const checkDate = {
  checkInDate: today,
  checkOutDate: today,
};

var today = new Date();
var dd = String(today.getDate()).padStart(2, "0");
var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!

today = mm + "/" + dd;

const addCheckDate = (state = checkDate, action) => {
  switch (action.type) {
    case "ADD_CHECK_DATE": {
      const newCheckInDate = action.payload.checkInDate;
      const newCheckOutDate = action.payload.checkOutDate;

      return {
        ...state,
        checkInDate: newCheckInDate,
        checkOutDate: newCheckOutDate,
      };
    }

    default:
      return state;
  }
};
export default addCheckDate;
